import { createTheme } from '@mui/material/styles'
import { PRIMARY, PRIMARY_HOVER } from '../GlobalStyles/globalColors'

const THEME_COLOR = PRIMARY
const THEME_HOVER = PRIMARY_HOVER

const muiTheme = createTheme({
  palette: {
    primary: {
      main:  THEME_COLOR,
      dark:  THEME_HOVER,
      light: '#fce7f3',
      contrastText: '#ffffff',
    },
    background: {
      default: '#f8fafc',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: "'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif",
    button: { textTransform: 'none', fontWeight: 700 },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: {
        root: {
          borderRadius: 10,
          fontWeight: 700,
          fontSize: 13,
          textTransform: 'none',
          padding: '9px 20px',
          lineHeight: 1.5,
          boxShadow: 'none',
        },
        containedPrimary: {
          backgroundColor: THEME_COLOR,
          '&:hover': { backgroundColor: THEME_HOVER, boxShadow: '0 4px 12px rgba(234, 76, 137, 0.25)' },
        },
        outlinedPrimary: {
          borderColor: THEME_COLOR,
          color: THEME_COLOR,
          '&:hover': { backgroundColor: '#fdf2f7', borderColor: THEME_COLOR },
        },
        sizeSmall: { fontSize: 12, padding: '6px 14px' },
        sizeLarge: { fontSize: 15, padding: '12px 28px' },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: { borderRadius: 8 },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          fontSize: 14,
          backgroundColor: '#ffffff',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#cbd5e1',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#94a3b8',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: THEME_COLOR,
            borderWidth: '1.5px',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontSize: 14,
          fontWeight: 500,
          color: '#64748b',
          '&.Mui-focused': {
            color: THEME_COLOR,
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          display: 'flex',
          alignItems: 'center',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: 14,
          borderRadius: 6,
          margin: '2px 6px',
          '&:hover': {
            backgroundColor: '#fdf2f7',
            color: THEME_COLOR,
          },
          '&.Mui-selected': {
            backgroundColor: '#fce7f3',
            color: THEME_COLOR,
            fontWeight: 600,
            '&:hover': {
              backgroundColor: '#fce7f3',
            },
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        elevation1: {
          boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.08), 0 8px 10px -6px rgba(0, 0, 0, 0.04)',
          borderRadius: 12,
          border: '1px solid #e2e8f0',
        },
      },
    },
  },
})

export default muiTheme
